module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "page-header",
    staticStyle: {
      "padding": "0 1em",
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn sp-button-02 sp-button-02-lt",
    on: {
      "click": function($event) {
        _vm.setMenuLink('profile', 'profile')
      }
    }
  }, [_vm._v("View Profile")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('profile', 'profile')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.user.user_name))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em",
      "clear": "both",
      "padding": "0 1em",
      "margin-bottom": "1em"
    }
  }, [_c('div', {
    staticClass: "card card-colord-01 card-colord-pad mt1"
  }, [_c('p', [_vm._v("Your Shop Statistics")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02 sp-button-02-lt",
    on: {
      "click": function($event) {
        _vm.setMenuLink('business')
      }
    }
  }, [_vm._v("Go to Store")])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-out-colord-pad mt1 hgt-slab"
  }, [_c('h4', [_vm._v("Best Sellers")]), _vm._v(" "), _c('p', [_vm._v("Your most purchased products")]), _vm._v(" "), (_vm.sellpoint.business_categories && (_vm.sellpoint.business_categories.length > 1)) ? _c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.reco_products), function(product, index) {
    return _c('li', [_c('div', {
      staticClass: "card col-xs-6 card-col-2",
      staticStyle: {
        "margin-bottom": "0.8em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + product.product_url_name
      }
    }, [_c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "margin-bottom": "0.8em",
        "border-left": "#f5f5f5 solid 0.35em",
        "border-radius": "4px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e(), _vm._v(" "), ((product.product_items[0].product_item_min_wholesale_order && (product.product_items[0].product_item_min_wholesale_order > 0))) ? _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("min.order(>" + _vm._s(product.product_items[0].product_item_min_wholesale_order) + ")")]) : _vm._e()]), _vm._v(" "), _vm._m(2, true)])])])])
  }))]) : _vm._e()]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "width": "50",
      "height": "50"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', [_c('b', [_vm._v("Orders")])]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("45")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Products")])]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("95")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Categoriess")])]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("5")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Customers")])]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("85")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-colord-01 card-colord-pad mt1 hgt-slab"
  }, [_c('div', {
    staticClass: "col-xs-3",
    staticStyle: {
      "text-align": "center",
      "padding": "1.2em 5px",
      "background-color": "#ffffff"
    }
  }, [_c('i', {
    staticClass: "wn-icon-lgflt fa fa-envelope",
    staticStyle: {
      "font-size": "42px",
      "color": "#ee4917"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9",
    staticStyle: {
      "background-color": "#f8f4f4",
      "padding": "1.2em 1.1em",
      "text-align": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "float": "right",
      "text-decoration": "underline"
    }
  }, [_c('b', [_vm._v("Inbox")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "clear": "right"
    }
  }, [_vm._v("You have (7) unread messages")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-out-colord-pad mt1 hgt-slab"
  }, [_c('h3', [_vm._v("Recent Orders")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ee4917"
    }
  }, [_vm._v("No orders yet")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', [_vm._v("view all")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table"
  }, [_c('th', [_vm._v("Order")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('tr', [_c('td')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11649f85"}!./src/pages/Account/Dashboard/template.html
// module id = 540
// module chunks = 0